module.exports = "<div class=\"container-fluid\" layout=\"vertical\" layout-fill>\r\n    <div class=\"row\">\r\n        <div class=\"col-sm-9\">\r\n            <h6>bar chart</h6>\r\n            <bar-horizontal></bar-horizontal>\r\n        </div>\r\n    </div>\r\n\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/emxd-charts/bar-horizontal/index.html
// module id = 92
// module chunks = 0